import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';
import moment from 'moment'


import Vue from 'vue'


const getDefaultStateForDocMilestones = () => {
  return {
    milestones: [],
    data:{}
  }
}

// state
const state = getDefaultStateForDocMilestones()

// getters
const getters = {

}

// mutations
const mutations = {
    FETCH_ALL(state, data){
        data.forEach(function(element) {
            element.time_created = (element.time_created != null && element.time_created != '') ? (moment(element.time_created).format('DD/MM/YYYY, h:mm a')) : '-'
        });
        state.milestones = data
    },
    RESET_STATE_FOR_DOC_MILESTONES (state) {
      Object.assign(state, getDefaultStateForDocMilestones())
    },
}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
      commit("RESET_STATE_FOR_DOC_MILESTONES")
    },
    print({ commit }, data) {
      return axios.post(apiRoutes['MILESTONE_PRINT'], data, authHeader())
      .then(response => {
        if(response.data.code == 1)
        {
          //commit('FETCH_ALL', response.data.data)
        } 
        else 
        {
          //commit('FETCH_ALL', [])
        }
      })
      .catch(error => {
        if (error.response) {
          console.log(error.response)
            Vue.notify({
                group: 'notify',
                type: 'error',
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300
            })
        } else {
            console.log("Problem Querying Data!", error);
        }
      });
    },
    fetchAll({ commit }, data) {
        return axios.post(apiRoutes['LIST_MILESTONES'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('FETCH_ALL', response.data.data)
              } 
              else 
              {
                commit('FETCH_ALL', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    }
}

export {
    state,
    getters,
    actions,
    mutations
}
